import { render, staticRenderFns } from "./ViajeCambioVentana.vue?vue&type=template&id=04c789ee"
import script from "./ViajeCambioVentana.vue?vue&type=script&lang=js"
export * from "./ViajeCambioVentana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports